// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-div[data-v-f37991fa] {\n  background-color: white;\n  margin: 16px 0;\n  min-height: calc(100vh - 258px);\n  padding: 16px;\n  border-radius: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
